/* eslint-disable no-use-before-define */

export const getSearchParams = (rs, keyword) =>
    []
    .concat(getSymbolSearchParams(rs))
    .concat(getIssuerSearchParams(rs))
    .concat(getCusipSearchParams(rs, keyword))
    .filter(Boolean)

export const getSymbolSearchParams = (rs) => Object.values(rs.reduce((x,r) => {
    let t = r.type
    if (t!=='C') return x

    let k = r.symbol
    if (k in x) return x

    x[k] = {
        symbol:k,
        searchParams:{
            holdInvType:['C'],
            holdSymbol:[k]
        }
    }
    return x
}, {}))

export const getIssuerSearchParams = (rs) =>  Object.values(rs.reduce((x,r) => {
    let k = r.issue
    if (k in x) return x

    x[k] = {
        issue:k,
        searchParams:{
            holdIssue:[k]
        }
    }
    return x
}, {}))

export const getCusipSearchParams = (rs, keyword) => Object.values(rs.reduce((x,r) => {
    let c = r.cusip
    let i = r.isin
    let k = c.indexOf(keyword) < 0 && i.indexOf(keyword)<0 ? c.substring(0,6) : c
    if (k in x) return x

    x[k] = {
        cusip:k,
        searchParams:{
            holdCusip:[k],
            holdIdentifierLabel: "holdCusip",
            holdIdentifiers:[k]
        }
    }
    return x
}, {}))




// WEBPACK FOOTER //
// ./src/header/global-search/search-params.js